import { takeEvery } from 'redux-saga/effects';

import type { KeyIndicatorsData } from '@payaca/types/analyticsTypes';
import { handleAsyncAction } from '../utils';
import { getKeyIndicatorsData } from './analyticsActions';
import type {
  AnalyticsSagaConfig,
  GetKeyIndicatorsData,
} from './analyticsTypes';
import { AnalyticsActionTypes } from './analyticsTypes';

const analyticsSagaCreator = ({
  apiBaseurl,
  getAuthHeader,
}: AnalyticsSagaConfig) => {
  const handleGetKeyIndicatorsData = handleAsyncAction<GetKeyIndicatorsData>(
    getKeyIndicatorsData,
    async (payload) => {
      const urlSearchParams = new URLSearchParams();
      payload.indicatorTypes?.forEach((indicatorType, index) => {
        urlSearchParams.set(`types[${index}]`, indicatorType);
      });

      // oxlint-disable-next-line typescript/await-thenable -- FIXME: pre-existing error: Unexpected `await` of a non-Promise (non-"Thenable") value.
      const authHeader = await getAuthHeader();

      const response = await fetch(
        `${apiBaseurl}/api/performance/key_indicators_data?${urlSearchParams.toString()}`,
        {
          method: 'GET',
          headers: {
            Authorization: authHeader,
            'Content-Type': 'application/json',
            'X-Simple-Job': 'true',
          },
        }
      );

      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Failed to get key indicators data');
      }
    },
    (response, payload) => {
      payload.payload?.callback?.(
        (response as KeyIndicatorsData).keyIndicatorData
      );
    },
    (error, payload) => {
      payload.payload?.onErrorCallback?.(error);
    }
  );

  return function* () {
    yield takeEvery(
      AnalyticsActionTypes.REQUEST_GET_KEY_INDICATORS_DATA,
      handleGetKeyIndicatorsData
    );
  };
};

export default analyticsSagaCreator;
